import type { ReactNode } from "react"
import { Link } from "react-router-dom"
import { Logo } from "./Logo"
import { cn } from "@/lib/utils"

interface PageShellProps {
  children: ReactNode
  bg?: "white" | "cream" | "subtle"
  header?: ReactNode
  className?: string
}

export function PageShell({ children, bg = "white", header, className }: PageShellProps) {
  const bgClass =
    bg === "cream" ? "bg-[#FAFAF7]" : bg === "subtle" ? "bg-gradient-to-b from-white to-[#F8FAFC]" : "bg-white"
  return (
    <div className={cn("min-h-screen", bgClass, "text-[#0F1B36]", className)}>
      <header className="border-b border-[#E5E7EB]/70 bg-white/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo size="md" />
          </Link>
          {header}
        </div>
      </header>
      {children}
    </div>
  )
}
